module.exports = __webpack_public_path__ + "img/step46_a_lift_printer_lowest.e1541c38.png";